import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const wrapperStyles = cssMap({
	root: {
		borderRadius: token('radius.large'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		transition: 'box-shadow 0.25s ease-in-out',
		overflow: 'hidden',
		'&:hover': {
			cursor: 'pointer',
			textDecoration: 'none',
			transitionProperty: 'background-color',
			transitionDuration: '400ms',
			transitionTimingFunction: 'ease-in-out',
			transitionDelay: '0ms',
		},
		width: '100%',
		height: '100%',
		minWidth: '160px',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		position: 'relative',
	},
});

export const PersonCardWrapper = ({
	id,
	children,
	testId,
}: {
	id: string;
	testId?: string;
	children: React.ReactNode;
}): React.JSX.Element => {
	const [isHovered, setIsHovered] = React.useState(false);
	return (
		<Box
			xcss={cx(wrapperStyles.root)}
			backgroundColor={isHovered ? 'elevation.surface.hovered' : 'elevation.surface'}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			testId={testId || `person-card-${id}`}
		>
			{children}
		</Box>
	);
};
